import { HisUploadFile } from '../model/his-upload-file';

export class HisUploadFileUtil {

    /**
     * Removes the file from the files array
     *
     * @param files the files array
     * @param file the file to remove
     * @return an array of {@code HisUploadFile}s
     */
    public static removeHisUploadFile(files: HisUploadFile[], file: HisUploadFile): HisUploadFile[] {
        for(let uploadFile of files) {
            //console.log('removeFile #uploadFile', uploadFile);

            if(uploadFile.name === file.name && uploadFile.base64 === file.base64) {
                //console.log('removeFile #uploadFile #foundFile', uploadFile);
                let index = files.indexOf(uploadFile);
                if (index !== -1) {
                    files.splice(index, 1);
                    return files;
                }
            }
        }
        return files;
    }

    /**
     * Checks, if all element of files2 are contained in files1
     *
     * @returns true, if all elements of files2 are contained in files1, false otheweise
     */
    public static containsFiles(files1: HisUploadFile[], files2: HisUploadFile[]): boolean {
        if(files1.every(r => files2.includes(r))) {
            return true;
        }
        return false;
    }

    /**
     * Checks, if all elements of files1 are contained in files.
     *
     * @param files1
     * @param files2
     *
     * @returns an array of missing files as {@code HisUploadFile}
     * */
    public static getNotContainedFiles(files1: HisUploadFile[], files2: HisUploadFile[]) {

        if(!files1 || !files2) {
            return [];
        }

        let missing = files2.filter(item => files1.indexOf(item) < 0);
        console.log('missing', missing);
        return missing;
    }

}
